import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function IsoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"iso"}/>
}
